import { call, put, select, takeLeading } from "redux-saga/effects";
import { accessTokenSelector } from "../../auth/selectors/token";
import MetricsService from "../services/Metrics.service";
import {
  FETCH_CATALOG_REQUEST,
  fetchCatalogSuccess,
  fetchCatalogFailure,
} from "../actions/catalog";

export function* fetchCatalogSaga() {
  try {
    const service = new MetricsService();
    const token = yield select(accessTokenSelector);
    const data = yield call([service, service.getCatalog], { token });
    yield put(fetchCatalogSuccess(data));
  } catch (error) {
    yield put(fetchCatalogFailure(error));
  }
}

export default function* watchCatalog() {
  yield takeLeading(FETCH_CATALOG_REQUEST, fetchCatalogSaga);
}
